export default __webpack_public_path__ + "static/media/recipe-finder-img.089f48cd.png";